import { z } from "zod";

/**
 * Reserve id is a nanoid generated client-side: reserve photos are linked by
 * this id (caption `slot:reserves.<id>.photo`), never by array index, since
 * an index would shift when a reserve is deleted.
 */
export const pvReceptionReserveSchema = z.object({
  id: z.string(),
  description: z.string().optional(),
});
export type PvReceptionReserve = z.infer<typeof pvReceptionReserveSchema>;

export const pvReceptionReservesSchema = z.array(pvReceptionReserveSchema);
export type PvReceptionReserves = z.infer<typeof pvReceptionReservesSchema>;
